export default {
  name: 'ShButton',

  props: {
    type: {
      type: String,
      default: 'default',
    },
    ripple: {
      type: Boolean,
      default: true,
    },
    outline: Boolean,
    disabled: Boolean,
    circle: Boolean,
    circleXl: Boolean,
    circleXxl: Boolean,
    edit: Boolean,
    add: Boolean,
    remove: Boolean,
    cancel: Boolean,
    show: Boolean,
    large: Boolean,
    small: Boolean,
    block: Boolean,
  },

  methods: {
    handleClick() {
      if (!this.disabled) this.$emit('click');
    },
  },
};
